import styled, { device, color } from '@styled'

export const SectionWrapper = styled.section`
  padding-block-start: 10px;
  padding-block-end: 50px;
  ${device.medium} {
    padding-block-end: 70px;
  }
  ${device.large} {
    padding-block-end: 90px;
  }
  ${color}
`

export const StyledText = styled.div`
  margin-block-start: 15px;
  margin-block-end: 25px;
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`

export const SectionBottom = styled.div`
  margin-block-start: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ${device.small} {
    flex-direction: row;
  }
`

export const OwnTh = styled.th`
  text-align: right;
  padding-right: 15px;
  ${device.small} {
    padding-right: 20px;
  }
  ${device.medium} {
    padding-right: 50px;
  }
  ${device.large} {
    padding-right: 70px;
  }
  ${device.xlarge} {
    padding-right: 90px;
  }
`

export const OwnTd = styled.td`
  text-align: right;
  padding-right: 15px;
  ${device.small} {
    padding-right: 20px;
  }
  ${device.medium} {
    padding-right: 50px;
  }
  ${device.large} {
    padding-right: 70px;
  }
  ${device.xlarge} {
    padding-right: 90px;
  }
`
